/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as ConnectAuthorizeRouteImport } from './routes/connect.authorize'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppPacksRouteImport } from './routes/_app/packs'
import { Route as AppKitsRouteImport } from './routes/_app/kits'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppInventoryIndexRouteImport } from './routes/_app/inventory.index'
import { Route as AppPackIdRouteImport } from './routes/_app/pack.$id'
import { Route as AppInventoryNewRouteImport } from './routes/_app/inventory.new'
import { Route as AppInventoryItemIdRouteImport } from './routes/_app/inventory.$itemId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const ConnectAuthorizeRoute = ConnectAuthorizeRouteImport.update({
  id: '/connect/authorize',
  path: '/connect/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppPacksRoute = AppPacksRouteImport.update({
  id: '/packs',
  path: '/packs',
  getParentRoute: () => AppRoute,
} as any)
const AppKitsRoute = AppKitsRouteImport.update({
  id: '/kits',
  path: '/kits',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryRoute,
} as any)
const AppPackIdRoute = AppPackIdRouteImport.update({
  id: '/pack/$id',
  path: '/pack/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryNewRoute = AppInventoryNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppInventoryRoute,
} as any)
const AppInventoryItemIdRoute = AppInventoryItemIdRouteImport.update({
  id: '/$itemId',
  path: '/$itemId',
  getParentRoute: () => AppInventoryRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/inventory': typeof AppInventoryRouteWithChildren
  '/kits': typeof AppKitsRoute
  '/packs': typeof AppPacksRoute
  '/settings': typeof AppSettingsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/connect/authorize': typeof ConnectAuthorizeRoute
  '/inventory/$itemId': typeof AppInventoryItemIdRoute
  '/inventory/new': typeof AppInventoryNewRoute
  '/pack/$id': typeof AppPackIdRoute
  '/inventory/': typeof AppInventoryIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/kits': typeof AppKitsRoute
  '/packs': typeof AppPacksRoute
  '/settings': typeof AppSettingsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/connect/authorize': typeof ConnectAuthorizeRoute
  '/': typeof AppIndexRoute
  '/inventory/$itemId': typeof AppInventoryItemIdRoute
  '/inventory/new': typeof AppInventoryNewRoute
  '/pack/$id': typeof AppPackIdRoute
  '/inventory': typeof AppInventoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/_app/inventory': typeof AppInventoryRouteWithChildren
  '/_app/kits': typeof AppKitsRoute
  '/_app/packs': typeof AppPacksRoute
  '/_app/settings': typeof AppSettingsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/connect/authorize': typeof ConnectAuthorizeRoute
  '/_app/': typeof AppIndexRoute
  '/_app/inventory/$itemId': typeof AppInventoryItemIdRoute
  '/_app/inventory/new': typeof AppInventoryNewRoute
  '/_app/pack/$id': typeof AppPackIdRoute
  '/_app/inventory/': typeof AppInventoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/onboarding'
    | '/inventory'
    | '/kits'
    | '/packs'
    | '/settings'
    | '/auth/login'
    | '/auth/register'
    | '/connect/authorize'
    | '/inventory/$itemId'
    | '/inventory/new'
    | '/pack/$id'
    | '/inventory/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/onboarding'
    | '/kits'
    | '/packs'
    | '/settings'
    | '/auth/login'
    | '/auth/register'
    | '/connect/authorize'
    | '/'
    | '/inventory/$itemId'
    | '/inventory/new'
    | '/pack/$id'
    | '/inventory'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/onboarding'
    | '/_app/inventory'
    | '/_app/kits'
    | '/_app/packs'
    | '/_app/settings'
    | '/auth/login'
    | '/auth/register'
    | '/connect/authorize'
    | '/_app/'
    | '/_app/inventory/$itemId'
    | '/_app/inventory/new'
    | '/_app/pack/$id'
    | '/_app/inventory/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  ConnectAuthorizeRoute: typeof ConnectAuthorizeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/connect/authorize': {
      id: '/connect/authorize'
      path: '/connect/authorize'
      fullPath: '/connect/authorize'
      preLoaderRoute: typeof ConnectAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/packs': {
      id: '/_app/packs'
      path: '/packs'
      fullPath: '/packs'
      preLoaderRoute: typeof AppPacksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kits': {
      id: '/_app/kits'
      path: '/kits'
      fullPath: '/kits'
      preLoaderRoute: typeof AppKitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/': {
      id: '/_app/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AppInventoryIndexRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/pack/$id': {
      id: '/_app/pack/$id'
      path: '/pack/$id'
      fullPath: '/pack/$id'
      preLoaderRoute: typeof AppPackIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/new': {
      id: '/_app/inventory/new'
      path: '/new'
      fullPath: '/inventory/new'
      preLoaderRoute: typeof AppInventoryNewRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/inventory/$itemId': {
      id: '/_app/inventory/$itemId'
      path: '/$itemId'
      fullPath: '/inventory/$itemId'
      preLoaderRoute: typeof AppInventoryItemIdRouteImport
      parentRoute: typeof AppInventoryRoute
    }
  }
}

interface AppInventoryRouteChildren {
  AppInventoryItemIdRoute: typeof AppInventoryItemIdRoute
  AppInventoryNewRoute: typeof AppInventoryNewRoute
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
}

const AppInventoryRouteChildren: AppInventoryRouteChildren = {
  AppInventoryItemIdRoute: AppInventoryItemIdRoute,
  AppInventoryNewRoute: AppInventoryNewRoute,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
}

const AppInventoryRouteWithChildren = AppInventoryRoute._addFileChildren(
  AppInventoryRouteChildren,
)

interface AppRouteChildren {
  AppInventoryRoute: typeof AppInventoryRouteWithChildren
  AppKitsRoute: typeof AppKitsRoute
  AppPacksRoute: typeof AppPacksRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPackIdRoute: typeof AppPackIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppInventoryRoute: AppInventoryRouteWithChildren,
  AppKitsRoute: AppKitsRoute,
  AppPacksRoute: AppPacksRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppPackIdRoute: AppPackIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  ConnectAuthorizeRoute: ConnectAuthorizeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
